/**
 * Application-wide constants
 */

export const TOTAL_STAGES = 5;

export const DEFAULT_MARGIN = {
    top: 20,
    right: 20,
    bottom: 60,
    left: 30
};

export const BAR_CONFIG = {
    maxHeight: 20,
    minHeight: 2,
    padding: 1
};

export const MAX_VISIBLE_HEIGHT = 600;

export const ANIMATION_DURATION = 1000;
export const PLAY_INTERVAL_DURATION = 3000;

export const DATA_PATH = 'data/race_results.csv';
